import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import AppConstants from '../../common/Constants';

const ElasticViewContainer = props => {
    // todo: make this more dynamic, no static names @jacksonkr
    const sharedWidth = useSharedValue(props.width || '100%');
    const sharedHeight = useSharedValue(props.height || '100%');

    const animatedStyle = useAnimatedStyle(() => {
        return {
            width: sharedWidth.value,
            height: sharedHeight.value
        };
    });

    useEffect(() => {
        sharedWidth.value = withTiming(props.width, { duration: 750 });
        sharedHeight.value = withTiming(props.height, { duration: 750 }, (fin) => Platform.OS === 'web' && window.dispatchEvent(new Event(AppConstants.WINDOW_EVENT_ELASTIC_ANIM_FINISH)));
    }, [props, sharedWidth, sharedHeight]);

    return (
        <Animated.View {...props} style={[props.style, animatedStyle]}>
            {props.children}
        </Animated.View>
    );
};

export default ElasticViewContainer;
